import React from "react"
import styled from "styled-components"
import { theme } from "../../../utils/theme"

const GridWrapper = styled.div`
  grid-column: span 2;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin-left: 3rem;
`

const Box = styled.canvas`
  width: 100%;
  margin: 0;
  display: block;
  background-color: ${props => props.col || props.theme.color.base1};
  border-radius: ${props => props.rtl || "0"} ${props => props.rtr || "0"}
    ${props => props.rbr || "0"} ${props => props.rbl || "0"};
`

const Circle = styled.div`
  display: block;
  position: absolute;
  width: 70%;
  height: 70%;
  margin: 15%;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: ${props => props.crcl || "transparent"};
  border-radius: 50%;
`

const BoxWrapper = styled.div`
  position: relative;
`

const BoxElement = props => {
  return (
    <BoxWrapper
      data-sal="slide-left"
      data-sal-delay={props.delay}
      data-sal-duration="600"
    >
      <Box
        width="1"
        height="1"
        rtl={props.rtl}
        rbr={props.rbr}
        rtr={props.rtr}
        rbl={props.rbl}
        col={props.col}
      ></Box>
      <Circle crcl={props.crcl} />
    </BoxWrapper>
  )
}

export const Grid = () => {
  return (
    <GridWrapper>
      {/*------ROW 1-------*/}

      <BoxElement col={theme.color.base9} crcl={theme.color.grey3} />

      <BoxElement col={theme.color.prim3} delay="100" />

      <BoxElement col="transparent" crcl={theme.color.grey3} delay="150" />

      <BoxElement rbl="100%" col={theme.color.grey7} delay="200" />

      <BoxElement rtr="100%" col={theme.color.prim1} delay="250" />

      {/*------ROW 2-------*/}

      <BoxElement rbl="100%" col={theme.color.grey7} delay="300" />

      <BoxElement
        col={theme.color.base7}
        crcl={theme.color.grey9}
        delay="350"
      />

      <BoxElement rtl="100%" col={theme.color.prim3} delay="400" />

      <BoxElement rtr="100%" col={theme.color.base7} delay="450" />

      <BoxElement
        col={theme.color.prim3}
        crcl={theme.color.grey3}
        delay="500"
      />

      {/*------ROW 3-------*/}

      <BoxElement col="transparent" />

      <BoxElement col="transparent" crcl={theme.color.prim1} delay="550" />

      <BoxElement col={theme.color.base8} delay="600" />

      <BoxElement col={theme.color.prim1} delay="650" />

      <BoxElement rtl="100%" col={theme.color.grey7} delay="700" />

      {/*------ROW 4-------*/}

      <BoxElement col="transparent" />

      <BoxElement col="transparent" />

      <BoxElement col="transparent" />

      <BoxElement col="transparent" crcl={theme.color.grey3} delay="750" />

      <BoxElement col={theme.color.grey3} delay="800" />
    </GridWrapper>
  )
}

export const Arrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="40px"
      height="40px"
      viewBox="0 0 85 85"
      stroke="red"
    >
      <g>
        <polyline
          fill="none"
          strokeWidth="10"
          strokeMiterlimit="10"
          points="10,80 80,80 80,10"
        />
        <line
          fill="none"
          strokeWidth="10"
          strokeMiterlimit="10"
          x1="80"
          y1="80"
          x2="5"
          y2="5"
        />
      </g>
    </svg>
  )
}

export const LinkedIn = () => {
  return (
    <svg
      height="512"
      viewBox="0 0 176 176"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_3536505"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="linkedin">
          <rect
            id="background"
            fill="#0077b5"
            height="176"
            rx="24"
            width="176"
          ></rect>
          <g id="icon" fill="#fff">
            <path d="m63.4 48a15 15 0 1 1 -15-15 15 15 0 0 1 15 15z"></path>
            <path d="m60 73v66.27a3.71 3.71 0 0 1 -3.71 3.73h-15.81a3.71 3.71 0 0 1 -3.72-3.72v-66.28a3.72 3.72 0 0 1 3.72-3.72h15.81a3.72 3.72 0 0 1 3.71 3.72z"></path>
            <path d="m142.64 107.5v32.08a3.41 3.41 0 0 1 -3.42 3.42h-17a3.41 3.41 0 0 1 -3.42-3.42v-31.09c0-4.64 1.36-20.32-12.13-20.32-10.45 0-12.58 10.73-13 15.55v35.86a3.42 3.42 0 0 1 -3.37 3.42h-16.42a3.41 3.41 0 0 1 -3.41-3.42v-66.87a3.41 3.41 0 0 1 3.41-3.42h16.42a3.42 3.42 0 0 1 3.42 3.42v5.78c3.88-5.82 9.63-10.31 21.9-10.31 27.18 0 27.02 25.38 27.02 39.32z"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Background1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100%"
      height="auto"
      viewBox="0 0 800 800"
    >
      <rect
        x="640"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FECF98"
        width="159.999"
        height="160"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#558BFF"
        d="M799.999,0H640c0,42.435,16.859,83.13,46.859,113.135
	C716.87,143.141,757.565,160,799.999,160V0z"
      />
      <rect
        x="480.003"
        y="480.001"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FECF98"
        width="159.997"
        height="160"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FECF98"
        d="M319.999,480.001H160c0,42.435,16.857,83.13,46.862,113.14
	c30.006,30.006,70.702,46.86,113.137,46.86V480.001z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FECF98"
        d="M640,320.003c0-42.439-16.857-83.134-46.863-113.14
	C563.132,176.858,522.437,160,480.003,160v160.003H640z"
      />
      <rect
        x="160"
        y="160"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FECF98"
        width="160.001"
        height="160.003"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FF885E"
        d="M640,0H480.003c0,42.435,16.854,83.13,46.862,113.135
	C556.865,143.141,597.566,160,640,160V0z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FF885E"
        d="M799.999,640.001v-160H640c0,42.435,16.859,83.13,46.859,113.14
	C716.87,623.147,757.565,640.001,799.999,640.001z"
      />
      <rect
        x="319.999"
        y="320.003"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FF885E"
        width="160.004"
        height="159.999"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FF885E"
        d="M160,320.003H0c0,42.434,16.856,83.129,46.861,113.134
	c30.008,30.006,70.703,46.864,113.139,46.864l0,0V320.003z"
      />
      <rect
        x="319.999"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#F5F7FB"
        width="160.004"
        height="160"
      />
      <rect
        x="480.003"
        y="320.003"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#F5F7FB"
        width="159.997"
        height="159.999"
      />
      <rect
        x="160"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#A8D8FF"
        width="160.001"
        height="160"
      />
      <rect
        x="640"
        y="320.003"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#071E4C"
        width="159.999"
        height="159.999"
      />
      <rect
        x="640"
        y="640.001"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#071E4C"
        width="159.999"
        height="159.998"
      />
      <rect
        x="160"
        y="320.003"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#071E4C"
        width="160.001"
        height="159.999"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#559DFF"
        d="M319.999,320.003H160v159.999
	c42.435,0,83.132-16.858,113.137-46.864C303.142,403.132,319.999,362.437,319.999,320.003z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#A8D8FF"
        d="M480.003,160L480.003,160c-42.44,0-83.135,16.858-113.14,46.864
	c-30.006,30.005-46.864,70.701-46.864,113.14h160.004V160z"
      />
      <rect
        x="640"
        y="160"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#A8D8FF"
        width="159.999"
        height="160.003"
      />
      <rect
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FEEDD5"
        width="160"
        height="160"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#071E4C"
        d="M79.999,27.996c28.702,0,52.004,23.303,52.004,52.002
	c0,28.704-23.303,52.002-52.004,52.002c-28.701,0-52.001-23.299-52.001-52.002C27.997,51.299,51.297,27.996,79.999,27.996z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#071E4C"
        d="M559.999,663.038c28.698,0,52.002,23.299,52.002,52.001
	c0,28.7-23.304,52.004-52.002,52.004c-28.699,0-52.002-23.304-52.002-52.004C507.997,686.336,531.3,663.038,559.999,663.038z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#071E4C"
        d="M719.998,187.999c28.703,0,52.006,23.299,52.006,52.002
	c0,28.704-23.303,52.007-52.006,52.007c-28.699,0-51.998-23.303-51.998-52.007C668,211.298,691.299,187.999,719.998,187.999z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FFFFFF"
        d="M240,195.179c28.701,0,52.004,23.303,52.004,52.002
	c0,28.699-23.304,52.002-52.004,52.002s-52.002-23.303-52.002-52.002C187.998,218.482,211.299,195.179,240,195.179z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#558BFF"
        d="M397.479,505.518c28.704,0,52.008,23.303,52.008,52.002
	c0,28.703-23.304,52.001-52.008,52.001c-28.698,0-52.002-23.298-52.002-52.001C345.478,528.821,368.781,505.518,397.479,505.518z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FF885E"
        d="M555.063,347.998c28.699,0,52.003,23.303,52.003,52.002
	c0,28.702-23.304,52.006-52.003,52.006c-28.703,0-52.005-23.304-52.005-52.006C503.058,371.301,526.359,347.998,555.063,347.998z"
      />
    </svg>
  )
}
